import * as firebase from 'firebase';
import "firebase/auth";

var firebaseConfig = {
    apiKey: "AIzaSyDZ8zgPI_9Txn67TP2LWucNA-unFstNo5U",
    authDomain: "coaching-730a1.firebaseapp.com",
    databaseURL: "https://coaching-730a1.firebaseio.com",
    projectId: "coaching-730a1",
    storageBucket: "coaching-730a1.appspot.com",
    messagingSenderId: "834809303502",
    appId: "1:834809303502:web:dc6f4449b478bb709b9b9f",
    measurementId: "G-ZRP5K0H6WC"
  };
  
  // Initialize Firebase
  var app = firebase.initializeApp(firebaseConfig);
  firebase.firestore(app);
  
  export default firebase;